module.exports = __webpack_public_path__ + "static/media/CREMAL_MENU-normal.38b7d8fb.png";